module.exports = {
      id: "mushroom-cloud-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "2495daf7694b94d633e1e9925cf85201.svg#mushroom-cloud-usage",
      toString: function () {
        return this.url;
      }
    }